







































































































































































































































































































































































































































































































































import { debounce } from 'lodash';
import moment from 'moment';
import { v4 as uuidv4 } from 'uuid';
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';

import UiButton from '@/components/ui/UiButton.vue';
// model
import { RowAction, RowActionType } from '@/models/uiDataTable';

import UiCheckbox from './UiCheckbox.vue';
import UiDatePicker2 from './UiDatePicker2.vue';
import UiDropdown from './UiDropdown.vue';
import UiListItem from './UiListItem.vue';
import UiLoading from './UiLoading.vue';
import UiSelect2 from './UiSelect2.vue';
import UiTextEdit from './UiTextEdit.vue';
import UiTooltip from './UiTooltip.vue';

interface HeaderItem<T> {
  label: string;
  id?: string;
  defaultVisibility?: boolean;
  selector?: (item: T, index?: number) => unknown;
  defaultWidth?: string;
  groupLabel?: string;
  sortable?: boolean;
  filterable?: boolean;
  rangeFilter?: boolean;
  singleSelectFilter?: boolean;
  textAlignment?: 'left' | 'right';
  type: 'text' | 'number' | 'date';
  isPaginated?: boolean;
}

interface GroupHeaderItem {
  label: string;
  colspan: number;
}

@Component({
  components: {
    UiButton,
    UiLoading,
    UiDropdown,
    UiTextEdit,
    UiCheckbox,
    UiListItem,
    UiDatePicker2,
    UiTooltip,
    UiSelect2,
  },
})
export default class UiDataTable extends Vue {
  @Prop()
  public readonly isLoading?: boolean;

  @Prop({ default: true })
  public readonly showLoadingIcon?: boolean;

  @Prop()
  public readonly isMinorLoading?: boolean;

  @Prop()
  public readonly headers!: HeaderItem<unknown>[];

  @Prop({ default: [] })
  public readonly items!: unknown[];

  @Prop()
  public readonly noDataMessage?: string;

  @Prop({ default: false })
  public readonly hideableColumns!: boolean;

  @Prop({ default: false })
  public readonly resizeableColumns!: boolean;

  @Prop({ default: false })
  public readonly checkableRows!: boolean;

  @Prop()
  public readonly rowClassConditionMap?: any;

  @Prop({ default: false })
  public readonly showActionColumn!: boolean;

  @Prop()
  public actions?: (string | { label: string; value: unknown })[];

  @Prop()
  public rowActions?: RowAction[];

  @Prop()
  public readonly expandableRows?: boolean;

  @Prop()
  public readonly expandedRowId?: string;

  @Prop()
  public readonly showRefresh?: boolean;

  @Prop()
  public readonly alignTop?: boolean;

  @Prop()
  public readonly fixedTable?: boolean;

  @Prop({ default: false })
  public readonly showGroupHeaders?: boolean;

  @Prop()
  public readonly uniqueColumnValues?: { [id: string]: Array<string | number | object> };

  @Prop({ default: () => ({}) })
  public readonly columnLoadingState!: { [id: string]: boolean };

  @Prop({ default: '0' })
  public readonly stickyMargin!: string;

  @Prop()
  public readonly checkColumnWidth?: string;

  @Prop()
  public readonly actionColumnWidth?: string;

  @Prop({ default: false })
  public readonly scrollable?: boolean;

  @Prop({ default: '' })
  public readonly className?: string;

  @Prop({ default: false })
  public readonly isError?: boolean;

  @Prop({ default: 'There was an error loading the data.' })
  public readonly errorMessage?: string;

  @Prop({ default: '20rem' })
  public readonly minHeight!: string;

  @Prop()
  public readonly maxHeight?: string;

  @Prop({ required: false })
  public readonly selectedHeaders?: string[];

  @Prop({ default: false })
  public readonly shadedHeader?: boolean;

  @Prop({ default: 'tw-divide-y tw-divide-gray-300' })
  public readonly tbodyClassName?: string;

  @Prop()
  public readonly striped?: boolean;

  @Prop()
  public readonly headerVerticalAlignment?: 'top' | 'middle' | 'bottom';

  @Prop({ default: (item: unknown) => true })
  public readonly checkableRowCallback!: (item: unknown) => boolean;

  @Prop({ default: () => ({}) })
  readonly filters!: { [id: string]: string[] };

  @Prop()
  public readonly disabledDates!: { startDate?: string; endDate?: string };

  public selectedItems: unknown[] = [];
  public selectedIdxs: number[] = [];
  public resizingTh: HTMLTableColElement | null = null;
  public startOffset = 0;
  public visibleHeaders: HeaderItem<unknown>[] = [];
  public instanceId = uuidv4().substring(0, 8);
  public selectedSort: { id: string; asc: boolean } = { id: '', asc: false };
  public selectedFilter = '';
  public selectedFilters: { [id: string]: string[] } = {};
  // Anchor position (viewport coords) of the filter trigger button used to
  // position the floating filter dropdown via `position: fixed`. Using fixed
  // positioning prevents the dropdown from being clipped by the table's
  // `overflow:auto` wrapper. Recalculated on each openFilter call.
  public filterAnchor: { top: number; left: number; right: number } | null = null;
  public filterSearch = '';
  public filterChanged = false;
  public tempFilters: string[] = [];
  public onDebouncedSearchChange: any;
  public filterCurrentPage: { [id: string]: number } = {};
  public filterItemsPerPage = 50;

  public get selectedItemsSet(): Set<unknown> {
    return new Set(this.selectedItems);
  }

  public clearSort() {
    this.selectedSort.id = '';
    this.selectedSort.asc = false;
    this.$emit('sort', this.selectedSort);
  }

  public clearFilter(headerId: string): void {
    this.selectedFilters[headerId]?.splice(0, this.selectedFilters[headerId].length);
    this.filterChanged = true;
    this.filterSearch = '';
    this.filterCurrentPage[headerId] = 1;
    this.onSearchChange(headerId);
  }

  public clearRangeFilter(headerId: string, index: number): void {
    this.selectedFilters[headerId][index] = '';
    if (this.selectedFilters[headerId].every((v) => !v.length)) this.selectedFilters[headerId] = [];
    this.filterChanged = true;
  }

  public rangeFilterChange() {
    this.filterChanged = true;
  }

  public onSearchChange(column: string) {
    // Reset to page 1 when search changes
    this.filterCurrentPage[column] = 1;
    this.$emit('search', { search: this.filterSearch, column });
  }

  public goToFilterPage(page: number): void {
    if (page >= 1 && page <= this.filterTotalPages) {
      Vue.set(this.filterCurrentPage, this.selectedFilter, page);
    }
  }

  public nextFilterPage(): void {
    if (this.filterCurrentPageNumber < this.filterTotalPages) {
      this.goToFilterPage(this.filterCurrentPageNumber + 1);
    }
  }

  public previousFilterPage(): void {
    if (this.filterCurrentPageNumber > 1) {
      this.goToFilterPage(this.filterCurrentPageNumber - 1);
    }
  }

  public get filterPageOptions(): number[] {
    const totalPages = this.filterTotalPages;
    const pages: number[] = [];
    for (let i = 1; i <= totalPages; i++) {
      pages.push(i);
    }
    return pages;
  }

  public get allFilteredValues(): string[] | object[] {
    if (!this.uniqueColumnValues) {
      return (
        this.items?.reduce((acc: string[], item: any) => {
          const value = item[this.selectedFilter]?.toString() as string;
          if (value && !acc.includes(value) && value.toLowerCase().includes(this.filterSearch.toLowerCase())) {
            acc.push(value);
          }
          return acc;
        }, [] as string[]) || []
      );
    } else {
      return (
        (this.uniqueColumnValues[this.selectedFilter] || []).reduce((acc: string[], item: any) => {
          if (typeof item === 'string') {
            const value = item?.toString() as string;
            if (value && !acc.includes(value) && value.toLowerCase().includes(this.filterSearch.toLowerCase())) {
              acc.push(value);
            }
          } else if (typeof item === 'object') {
            const value = item?.label?.toString() as string;
            if (
              value &&
              !Object.values(acc).includes(value) &&
              value.toLowerCase().includes(this.filterSearch.toLowerCase())
            ) {
              acc.push(item);
            }
          }
          return acc;
        }, [] as string[]) || []
      );
    }
  }

  public get uniqueFilterValues(): string[] | object[] {
    const currentHeader = this.headers.find((h) => (h.id || h.label) === this.selectedFilter);
    if (!currentHeader?.isPaginated) {
      return this.allFilteredValues;
    }

    const currentPage = this.filterCurrentPage[this.selectedFilter] || 1;
    const start = (currentPage - 1) * this.filterItemsPerPage;
    const end = start + this.filterItemsPerPage;
    return this.allFilteredValues.slice(start, end);
  }

  public get filterTotalPages(): number {
    return Math.ceil(this.allFilteredValues.length / this.filterItemsPerPage) || 1;
  }

  public get filterCurrentPageNumber(): number {
    return this.filterCurrentPage[this.selectedFilter] || 1;
  }

  public get visibleGroupHeaders(): GroupHeaderItem[] {
    if (this.showGroupHeaders === false) return [];
    return this.actualVisibleHeaders.reduce((acc, header) => {
      if (acc.length && acc[acc.length - 1].label === (header.groupLabel || '')) {
        acc[acc.length - 1].colspan++;
      } else {
        acc.push({
          label: header.groupLabel || '',
          colspan: 1,
        });
      }
      return acc;
    }, [] as GroupHeaderItem[]);
  }

  public onSort(header: HeaderItem<unknown>) {
    if (!header.sortable) return;
    if (this.selectedSort.id === header.id && this.selectedSort.asc) {
      this.selectedSort.id = '';
      this.selectedSort.asc = false;
    } else {
      this.selectedSort.asc = this.selectedSort.id === header.id ? !this.selectedSort.asc : false;
      this.selectedSort.id = header.id || header.label;
    }
    this.$emit('sort', this.selectedSort);
  }

  public changeFilter(value: string, header: HeaderItem<unknown>) {
    this.selectedFilters[header.id || header.label] = [value];
    this.filterChanged = true;
  }

  public addFilter(value: string | { id: string; label: string }, header: HeaderItem<unknown>) {
    if (!this.filterChanged) {
      this.tempFilters = [...this.selectedFilters[header.id || header.label]];
    }

    const filterValue = typeof value === 'object' ? value?.id ?? undefined : value;
    this.filterChanged = true;

    if (this.selectedFilters[header.id || header.label].includes(filterValue)) {
      this.selectedFilters[header.id || header.label].splice(
        this.selectedFilters[header.id || header.label].indexOf(filterValue),
        1
      );
    } else {
      this.selectedFilters[header.id || header.label].push(filterValue);
    }
  }

  public openFilter(header: HeaderItem<unknown>, event?: MouseEvent) {
    if (!header.filterable) return;
    this.selectedFilter = header.id || header.label;
    // Capture viewport coords of the trigger button so the fixed-positioned
    // dropdown can anchor to it (otherwise it would be clipped by the table
    // wrapper's overflow:auto).
    const trigger = event?.currentTarget as HTMLElement | null;
    if (trigger) {
      const rect = trigger.getBoundingClientRect();
      this.filterAnchor = {
        top: rect.bottom,
        left: rect.left,
        right: window.innerWidth - rect.right,
      };
    }
    // Initialize pagination for this filter if not already set
    if (!this.filterCurrentPage[this.selectedFilter]) {
      Vue.set(this.filterCurrentPage, this.selectedFilter, 1);
    }
    this.$nextTick(() => {
      document.getElementById(this.selectedFilter + '-filter')?.focus();
    });
  }

  public get filterDropdownStyle(): Record<string, string> {
    if (!this.filterAnchor) return {};
    // Find the current header's index to mirror the original left/right
    // alignment behavior (dropdowns for right-half columns hug the right
    // edge of their trigger so they don't overflow the viewport).
    const idx = this.visibleHeaders.findIndex((h) => (h.id || h.label) === this.selectedFilter);
    const alignRight = idx > this.visibleHeaders.length / 2;
    const style: Record<string, string> = { top: `${this.filterAnchor.top}px` };
    if (alignRight) {
      style.right = `${this.filterAnchor.right}px`;
    } else {
      style.left = `${this.filterAnchor.left}px`;
    }
    return style;
  }

  public applyFilter() {
    this.selectedFilter = '';
    this.filterSearch = '';
    this.tempFilters = [];
    if (!this.filterChanged) return;
    this.$emit('filter', this.selectedFilters);
    this.filterChanged = false;
  }

  public closeFilter(headerId: string) {
    if (this.filterChanged) Vue.set(this.selectedFilters, this.selectedFilter, this.tempFilters);
    this.filterChanged = false;
    this.selectedFilter = '';
    this.filterSearch = '';
    this.tempFilters = [];
    this.onSearchChange(headerId);
  }

  @Watch('filters')
  onFilterPropChange(filters: { [id: string]: string[] }) {
    for (const column of Object.keys(filters)) {
      this.selectedFilters[column] = filters[column];
      this.filterChanged = true;
    }
  }

  public onGripMouseDown(e: MouseEvent) {
    const th = document.getElementById('col-' + (e as any).target.parentNode.id) as HTMLTableColElement;
    this.resizingTh = th;
    this.startOffset = th.offsetWidth - e.pageX;

    document.addEventListener('mousemove', this.onGripMouseMove);
    document.addEventListener('mouseup', this.onGripMouseUp);
  }

  public onGripMouseMove(e: MouseEvent) {
    if (this.resizingTh) {
      this.resizingTh.style.width = this.startOffset + e.pageX + 'px';
    }
  }

  public onGripMouseUp(e: MouseEvent) {
    this.resizingTh = null;
    document.removeEventListener('mousemove', this.onGripMouseMove);
    document.removeEventListener('mouseup', this.onGripMouseUp);
  }

  public rowClicked(item: unknown, index: number) {
    this.$emit('row-clicked', { item, row: (this.$refs.rows as HTMLElement[])[index] });
  }

  public rowHovered(item: unknown, index: number, isHovered: boolean) {
    this.$emit('row-hovered', { item, row: (this.$refs.rows as HTMLElement[])[index], value: isHovered });
  }

  public get isAllSelected() {
    return (this.items ?? []).length === this.selectedItems.length;
  }

  public set isAllSelected(newValue: boolean) {
    if (newValue) {
      this.selectedItems = this.items ?? [];
    } else {
      this.selectedItems = [];
    }
    this.$emit('selection-changed', this.selectedItems);
  }

  public get actualVisibleHeaders() {
    return this.selectedHeaders
      ? this.headers.filter((header) => this.selectedHeaders?.includes(header?.id ?? ''))
      : this.visibleHeaders;
  }

  @Watch('headers', { immediate: true })
  private onHeadersChanged(newHeaders: HeaderItem<unknown>[]) {
    this.selectedIdxs = [];
    newHeaders.forEach((header, index) => {
      if (header.defaultVisibility ?? true) {
        this.selectedIdxs.push(index);
      }
    });
    this.visibleHeaders = newHeaders.filter((header) => header.defaultVisibility ?? true);
    this.$nextTick(() => {
      this.headers.forEach((header) => {
        if (header.defaultWidth) {
          const elem = document.getElementById(`col-${this.instanceId}-${header.id}`);
          if (elem) {
            elem.style.width = header.defaultWidth;
          }
        }
      });
    });
  }

  public onItemSelectChange(checked: boolean, item: unknown) {
    if (checked) {
      this.selectedItems.push(item);
    } else {
      const itemsSet = this.selectedItemsSet;
      itemsSet.delete(item);
      this.selectedItems = Array.from(itemsSet);
    }
    this.$emit('selection-changed', this.selectedItems);
  }

  public clearSelection() {
    this.selectedItems = [];
    this.$emit('selection-changed', this.selectedItems);
  }

  @Watch('items')
  private onItemsChanged(newItems: unknown[] | undefined) {
    this.selectedItems = [];
  }

  async created() {
    this.headers
      .filter((x) => x.filterable)
      .forEach((header) => {
        Vue.set(this.selectedFilters, header.id || header.label, []);
      });

    this.onDebouncedSearchChange = debounce(this.onSearchChange, 100);
  }

  private get columnCount() {
    let count = this.actualVisibleHeaders.length;
    if (this.checkableRows) count++;
    if (this.actions || this.hideableColumns || this.showActionColumn || this.showRefresh) count++;
    return count;
  }

  public get calcClass() {
    return {
      'tw-overflow-x-scroll': this.scrollable,
      'tw-overflow-y-auto': this.scrollable,
      ...this.className?.split(' ').reduce((a, x) => {
        a[x] = true;
        return a;
      }, {} as { [key: string]: boolean }),
    };
  }

  public get calcStyle() {
    let style = `min-height: ${this.minHeight}`;
    if (this.maxHeight) style += `; max-height: ${this.maxHeight}`;
    if (this.selectedItems.length > 0) style += `; padding-bottom: 48px`;
    return style;
  }

  public get rowActionsButtons(): RowAction[] | undefined {
    return this.rowActions
      ?.filter((btn) => btn.type === RowActionType.Button)
      .sort((a, b) => a.sortIndex - b.sortIndex);
  }

  public get rowActionsDropdown(): RowAction[] | undefined {
    return this.rowActions
      ?.filter((btn) => btn.type === RowActionType.Dropdown)
      .sort((a, b) => a.sortIndex - b.sortIndex);
  }

  public async highlightRow(id: string) {
    const row = ((this.$refs.rows as []) || []).find((x: any) => x.getAttribute('data-id') === id) as any;
    if (row) {
      row.classList.add('row-transition');
      await this.$nextTick();
      row.classList.add('tw-bg-success-100');
      setTimeout(() => {
        row.classList.remove('tw-bg-success-100');
      }, 1000);
    }
  }

  getDisabledDates(date: any) {
    if (this.disabledDates.startDate) {
      // use the first_record_date in date format
      const calendarTimeUnix = moment(date).valueOf();
      const minTimeUnix = moment(this.disabledDates.startDate).valueOf();
      const nowUnix = new Date().valueOf();
      return calendarTimeUnix > nowUnix || calendarTimeUnix < minTimeUnix;
    } else {
      return false;
    }
  }

  getItemKey(item: any) {
    if (typeof item === 'string') return item;
    else if (item && typeof item === 'object' && Object.keys(item).includes('id')) return item.id;
    else return '';
  }

  getItemTitle(item: any) {
    if (typeof item === 'string') return item;
    else if (typeof item === 'object' && Object.keys(item).includes('label')) return item.label;
    else return '';
  }

  // Map a stored filter id back to its display label using uniqueColumnValues.
  // Needed when filter options are { id, label } objects (e.g. wallet name vs id)
  // so the selected chip shows the user-facing label, not the raw id.
  getFilterDisplayLabel(filter: string, header: HeaderItem<unknown>) {
    const columnKey = header.id || header.label;
    const options = this.uniqueColumnValues?.[columnKey];
    if (!options) return filter;
    const match = options.find(
      (item) => item && typeof item === 'object' && (item as { id?: string }).id === filter
    ) as { label?: string } | undefined;
    return match?.label ?? filter;
  }
}
